import React from 'react';
import { useDispatch } from 'react-redux';
import {changeVisibility} from '../redux/actions/filteringActions'

interface IProps {
  visibility?: string
}

function FilteringToggleAdminAll(props: IProps = {}) {
  console.log(props)
  const dispatch = useDispatch();
  return(
      <span>
          <span>VIDITELNOST: </span>
          <span className={props.visibility==="NORMAL"?"filterBtnStyle filterBtnStyleSelected":"filterBtnStyle"} onClick={()=>{console.log("set NORMAL"); dispatch(changeVisibility("NORMAL")); }}> NORMAL </span>
          <span className={props.visibility==="ALL"?"filterBtnStyle filterBtnStyleSelected":"filterBtnStyle"} onClick={()=>{console.log("set ALL"); dispatch(changeVisibility("ALL")); }}> ALL </span>
        </span>
    )
}
export default FilteringToggleAdminAll;
/*
// fixed query
let pouziti_list_ids = pouziti.filter((pouz: any) => {
  if (toggle === 'NORMAL') {
    return pouz.pouzitibool === 1;
  } else if (toggle === 'ALL') {
    return pouz.pouzitibool === 1 || pouz.pouzitibool === 0;
  }
})
.reduce((list: any, pouz: any) => ([...list, pouz.key]), []);
// w/ toggle
enum ToggleOption {
  NORMAL = 'NORMAL',
  ALL = 'ALL'
}

let toggle: ToggleOption = ToggleOption.NORMAL;

let pouziti_list_ids = pouziti.filter((pouz: any) => {
  if (toggle === ToggleOption.NORMAL) {
    return pouz.pouzitibool === 1;
  } else if (toggle === ToggleOption.ALL) {
    return true;
  }
})
.reduce((list: any, pouz: any) => ([...list, pouz.key]), []);
//some comp.
import React, { useState } from 'react';

enum ToggleOption {
  NORMAL = 'NORMAL',
  ALL = 'ALL'
}

const MyComponent = () => {
  const [toggle, setToggle] = useState<ToggleOption>(ToggleOption.NORMAL);
  const [pouzitiListIds, setPouzitiListIds] = useState<string[]>([]);

  const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setToggle(event.target.value as ToggleOption);
  };

  const filterPouzitiList = () => {
    const filteredPouzitiList = pouziti.filter((pouz: any) => {
      if (toggle === ToggleOption.NORMAL) {
        return pouz.pouzitibool === 1;
      } else if (toggle === ToggleOption.ALL) {
        return true;
      }
    })
    .reduce((list: any, pouz: any) => ([...list, pouz.key]), []);
    
    setPouzitiListIds(filteredPouzitiList);
  };

  // Call filterPouzitiList() whenever the toggle or pouziti array changes
  useEffect(() => {
    filterPouzitiList();
  }, [toggle, pouziti]);

  return (
    <div>
      <label>
        <input
          type="radio"
          value={ToggleOption.NORMAL}
          checked={toggle === ToggleOption.NORMAL}
          onChange={handleToggleChange}
        />
        Normal
      </label>
      <label>
        <input
          type="radio"
          value={ToggleOption.ALL}
          checked={toggle === ToggleOption.ALL}
          onChange={handleToggleChange}
        />
        All
      </label>
      <ul>
        {pouzitiListIds.map((id) => (
          <li key={id}>{id}</li>
        ))}
      </ul>
    </div>
  );
};
*/